class Sidebar {
  constructor() {
    this.sidebarElement = document.querySelector(".sidebar")

    if (this.sidebarElement) {
      this.toggleSidebarClass()

      window.addEventListener("resize", this.toggleSidebarClass.bind(this))
    }
  }

  /**
   * Disables stickiness of the sidebar when it is higher than the viewport
   */
  toggleSidebarClass() {
    this.sidebarElement.classList.toggle("sidebar--static", window.innerHeight < this.sidebarElement.offsetHeight)
  }
}

export default Sidebar
